interface ErrorOverlayProps {
  error: string | null
  onReload: () => void
}

export function ErrorOverlay({ error, onReload }: ErrorOverlayProps) {
  if (!error) return null

  return (
    <div className="absolute inset-0 flex items-center justify-center bg-black/90 z-50">
      <div className="bg-dark-900 border border-red-500/50 p-8 rounded-2xl max-w-md text-center shadow-2xl mx-4">
        <div className="w-12 h-12 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-4 text-red-400">
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
        </div>
        <h3 className="text-lg font-bold text-white mb-2">Setup Failed</h3>
        <p className="text-red-200 mb-6">{error}</p>
        <button
          onClick={onReload}
          className="px-6 py-2 bg-red-600 hover:bg-red-500 text-white rounded-lg font-medium"
        >
          Reload
        </button>
      </div>
    </div>
  )
}
